import { render, staticRenderFns } from "./DashboardAnexo1Geral.vue?vue&type=template&id=7942c1e2&"
import script from "./DashboardAnexo1Geral.vue?vue&type=script&lang=js&"
export * from "./DashboardAnexo1Geral.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAnexo1Geral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VTooltip})
